import cn from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { VerticalListContainer, VerticalListItem } from './styles';

export interface VerticalListProps {
  value?: string | number;
  isOpen?: boolean;
  options?: string[] | number[];
  placeholder?: string;
  /** 데이터가 없는 경우 노출하는 메세지 */
  fallback?: string;
  onClick?: (value: string | number) => void;
}

export const VerticalList = ({
  value,
  isOpen,
  options = [],
  onClick,
  placeholder
}: VerticalListProps) => {
  const [selectedValue, setSelectedValue] = useState<number | string>();
  const listRef = useRef<HTMLUListElement>(null);

  const handleClick = (selectedValud: string | number) => {
    setSelectedValue(selectedValud);

    if (onClick) {
      onClick(selectedValud);
    }
  };

  useEffect(() => {
    if (isOpen && listRef.current) {
      listRef.current.scrollTop = 0;
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && listRef.current) {
      const selected = listRef.current.querySelector(
        ':scope .selected'
      ) as HTMLElement;

      if (selected !== null) {
        const selectedRect = selected.getBoundingClientRect();
        const scrollableRect = listRef.current.getBoundingClientRect();

        if (
          selectedRect.top < scrollableRect.top ||
          selectedRect.bottom > scrollableRect.bottom
        ) {
          listRef.current.scrollTop =
            selected?.offsetTop - scrollableRect.height / 2 + 50;
        }
      }
    }
  }, [selectedValue, isOpen]);

  useEffect(() => {
    if (value) {
      setSelectedValue(String(value));
    }
  }, [value]);

  return (
    <VerticalListContainer isOpen={isOpen} ref={listRef}>
      {options.length > 0 ? (
        options.map((el: string | number) => {
          return (
            <VerticalListItem
              key={el}
              onClick={() => handleClick(el)}
              className={cn({ selected: selectedValue === el })}
            >
              {el}
            </VerticalListItem>
          );
        })
      ) : (
        <VerticalListItem>{placeholder}</VerticalListItem>
      )}
    </VerticalListContainer>
  );
};
